/*
    Made With Hate, Headaches and Rage by Francisco Bejarano ♥
    
	@param cursorObj , OBJECT
    
    export interface cursorObj {
        default: Default;
        extras:  Default[];
        styles:  Styles;
    }

    export interface Default {
        selector: string;
        cursor:   string;
    }

    export interface Styles { //for the moment, just dimensions (width, height)
        width:  number;
        height: number;
    }

    
*/
class HCCustomCursor {
  constructor(cursorObj) {
    this.default = cursorObj.default ? cursorObj.default : {};
    this.extras = cursorObj.extras ? cursorObj.extras : [];
    this.styles = cursorObj.styles ? cursorObj.styles : {};
  }

  init() {
    const cursor = document.querySelector(this.default.selector);
    const defaultCursor = this.default.cursor;
    if(!cursor) {
      throw new TypeError("HC Error - Cursor Element Not Found");
    }
console.log('this.extras',this.extras)
    cursor.style.width = this.styles.width + "px";
    cursor.style.height = this.styles.height  + "px";
    cursor.style.backgroundImage = `url(${defaultCursor})`;

    window.addEventListener('mousemove', function(e) {
      cursor.style.top = e.pageY + "px";
      cursor.style.left = e.pageX + "px";
    });
    
    if(this.extras.length > 0) {
      this.extras.forEach(extra => {
        document.querySelectorEver(extra.selector, element => {
          element.addEventListener('mouseover', function(e) {
            cursor.style.backgroundImage = `url(${extra.cursor})`;
            //cursor.style.transform ="scale(.5)";
            if(extra.custom_class && extra.custom_class !== '' && extra.type === 'hover') {
              cursor.classList.add(extra.custom_class)
            }
          });

          element.addEventListener('mouseout', function(e) {
            cursor.style.backgroundImage = `url(${defaultCursor})`;           
             //cursor.style.transform ="scale(1)";
            if(extra.custom_class && extra.type === 'hover') {
              cursor.classList.remove(extra.custom_class)
            }
          });
        });
      })
    }
  }
}